import React from "react";

import usePageContent from "../../hooks/usePageContent";
import EditableSection from "../../components/CMS/EditableSection";
import("../../app/styles/platform.css");

import PlatformIntroSection from "./PlatformHeroSection";
import PlatformExperienceSection from "./PlatformExperienceSection";
import PlatformCapabilitiesSection from "./PlatformCapabilitiesSection";
import PlatformSimulationsSection from "./PlatformSimulationsSection";
import PlatformRobotSection from "./PlatformRobotSection";
import PlatformCtaSection from "./PlatformCtaSection";


import GenericSectionEditor from "../../components/CMS/editors/GenericSectionEditor";


const PlatformPage = ({ user }) => {

    const {
        get,
        loading,
        error,
        refresh
    } = usePageContent("platform");


    const editable = !!user;


    if (loading) {
        return (
            <div className="container">
                <p>Loading...</p>
            </div>
        );
    }


    if (error) {
        return (
            <div className="container">
                <p>
                    Failed to load founders page.
                </p>
            </div>
        );
    }


    return (
        <div class="sx-platform-page">
            <EditableSection
                uniqueId="platform-intro"
                title="A Journey from Engineering to"
                data={get("intro")}
                Display={PlatformIntroSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="founders-simulation"
                title="A Journey from Engineering to"
                data={get("simulation")}
                Display={PlatformSimulationsSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="platform-robots"
                title="A Journey from Engineering to"
                data={get("robots")}
                Display={PlatformRobotSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="platform-intro"
                title="A Journey from Engineering to"
                data={get("experience")}
                Display={PlatformExperienceSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
             
            <EditableSection
                uniqueId="platform-capabilities"
                title="A Journey from Engineering to"
                data={get("capabilities")}
                Display={PlatformCapabilitiesSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />       

            {/* <EditableSection
                uniqueId="founders-cta"
                title="A Journey from Engineering to"
                data={get("cta")}
                Display={PlatformCtaSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />  */}
        </div>
    );
};


export default PlatformPage;